import { call, put } from "redux-saga/effects";

import * as API from "../../Connections/API/OrgManager";

import * as dispatchAction from "../Action/Actions";

export function* getTenantsSaga(action) {
  try {
    const response = yield call(API.getTenantsApi, action.data);
    yield put(dispatchAction.getAllTenantsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllTenantsFailAction(error));
  }
};

export function* editOrgSaga(action) {
  try {
    const response = yield call(API.editOrgApi, action.data);
    yield put(dispatchAction.editOrgSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.editOrgFailAction(error));
  }
};

export function* addTenantSaga(action) {
  try {
    const response = yield call(API.addTenantApi, action.data);
    yield put(dispatchAction.addTenantSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addTenantFailAction(error));
  }
};

export function* comparePolygonsSaga(action) {
  try {
    const response = yield call(API.comparePolygonsApi, action.data);
    yield put(dispatchAction.comparePolygonsChartSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.comparePolygonsChartFailAction(error));
  }
};

export function* editTenantSaga(action) {
  try {
    const response = yield call(API.editTenantApi, action.data);
    yield put(dispatchAction.editTenantSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.editTenantFailAction(error));
  }
};

export function* getOrgByIdSaga(action) {
  try {
    const response = yield call(API.getOrgByIdApi, action.data);
    yield put(dispatchAction.getOrgByIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrgByIdFailAction(error));
  }
};

export function* changeTenantActivationSaga(action) {
  try {
    const response = yield call(API.changeTenantActivationApi, action.data);
    yield put(dispatchAction.changeTenantActivationSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeTenantActivationFailAction(error));
  }
};

export function* deleteTenantSaga(action) {
  try {
    const response = yield call(API.deleteTenantApi, action.data);
    yield put(dispatchAction.deleteTenantSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.deleteTenantFailAction(error));
  }
};

export function* getTenantByIdSaga(action) {
  try {
    const response = yield call(API.getTenantByIdApi, action.data);
    yield put(dispatchAction.getTenantByIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getTenantByIdFailAction(error));
  }
};

export function* getOrganizationUserSaga(action) {
  try {
    const response = yield call(API.getOrganizationUserApi, action.data);
    yield put(dispatchAction.getOrganizationUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrganizationUserFailAction(error));
  }
};

export function* getTenantUserSaga(action) {
  try {
    const response = yield call(API.getTenantUserApi, action.data);
    yield put(dispatchAction.getTenantUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getTenantUserFailAction(error));
  }
};

export function* updateOrgUserSaga(action) {
  try {
    const response = yield call(API.updateOrgUserApi, action.data);
    yield put(dispatchAction.updateOrgUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateOrgUserFailAction(error));
  }
};

export function* updateTenantUserSaga(action) {
  try {
    const response = yield call(API.updateTenantUserApi, action.data);
    yield put(dispatchAction.updateTenantUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateTenantUserFailAction(error));
  }
};

export function* changeTenantPassowrdSaga(action) {
  try {
    const response = yield call(API.changeTenantPasswordApi, action.data);
    yield put(dispatchAction.changeTenantPasswordSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeTenantPasswordFailAction(error));
  }
};

export function* getUserTokenSaga(action) {
  try {
    const response = yield call(API.getUserTokenApi, action.data);
    yield put(dispatchAction.getUserTokenSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getUserTokenFailAction(error));
  }
};

export function* getUserTokenByTenantIdSaga(action) {
  try {
    const response = yield call(API.getUserTokenByTenantIdApi, action.data);
    yield put(dispatchAction.getUserTokenSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getUserTokenFailAction(error));
  }
};

export function* getOrganizationUsageSaga(action) {
  try {
    const response = yield call(API.getOrganizationUsageApi, action.data);
    yield put(dispatchAction.getOrganizationUsageSuccessAction(response, action.data.interval));
  } catch (error) {
    yield put(dispatchAction.getOrganizationUsageFailAction(error));
  }
};

export function* downloadUsageSaga(action) {
  try {
    const response = yield call(API.downloadUsageApi, action.data);
    yield put(dispatchAction.downloadUsageSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.downloadUsageFailAction(error));
  }
};

export function* getOrgPOCSaga(action) {
  try {
    const response = yield call(API.getOrgPOCApi, action.data);
    yield put(dispatchAction.getOrgPOCSuccessAction(response, action.data.interval));
  } catch (error) {
    yield put(dispatchAction.getOrgPOCFailAction(error));
  }
};

export function* updateOrgPOCSaga(action) {
  try {
    const response = yield call(API.updateOrgPOCApi, action.data);
    yield put(dispatchAction.updateOrgPOCSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateOrgPOCFailAction(error));
  }
};

export function* addOrgPOCSaga(action) {
  try {
    const response = yield call(API.addOrgPOCApi, action.data);
    yield put(dispatchAction.addOrgPOCTypeSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addOrgPOCTypeFailAction(error));
  }
};

export function* removeOrgPOCSaga(action) {
  try {
    const response = yield call(API.removeOrgPOCApi, action.data);
    yield put(dispatchAction.removeOrgPOCTypeSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.removeOrgPOCTypeFailAction(error));
  }
};

export function* deliveryReportSaga(action) {
  try {
    const response = yield call(API.deliveryReportApi, action.data);
    yield put(dispatchAction.deliveryReportSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.deliveryReportFailAction(error));
  }
};